import * as React from 'react';

type ActionRetryProps = Omit<React.SVGAttributes<SVGElement>, 'viewbox' | 'xmlns'>;

export const ActionRetry: React.FC<ActionRetryProps> = (props) => {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.2538 3.45397L10.4846 0.333008L10.295 2.60662C8.399 2.51247 6.50296 3.07737 4.98613 4.48962C0.056426 8.91467 2.90049 17.1057 9.63143 17.4823C13.8027 17.7648 17.1208 14.5637 17.5 10.4211L15.9832 10.3269C15.6988 13.6222 13.0443 16.1642 9.63143 15.9759C4.32252 15.6935 1.85766 9.10297 5.83935 5.52527C7.07178 4.39547 8.49381 3.92472 10.295 4.01887L10.1054 6.19834L13.2538 3.45397Z" />
    </svg>
  );
};
